var _circle, _circle2, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgNavIconReferrals = function SvgNavIconReferrals(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.304,
    cy: 9.756,
    r: 3.5,
    stroke: "currentColor",
    fill: "none"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.804,
    cy: 11.256,
    r: 3,
    stroke: "currentColor",
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 19.013 18.409 C 19.31 18.314 20.044 16.699 22.904 16.256 L 24.704 16.256 C 27.521 16.256 29.804 18.539 29.804 21.356 C 29.804 21.853 29.401 22.256 28.904 22.256 L 18.704 22.256",
    stroke: "currentColor",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 6.804 21.156 C 6.804 17.898 9.446 15.256 12.704 15.256 L 13.904 15.256 C 17.163 15.256 19.804 17.898 19.804 21.156 C 19.804 21.764 19.312 22.256 18.704 22.256 L 7.904 22.256 C 7.297 22.256 6.804 21.764 6.804 21.156 Z",
    stroke: "currentColor",
    fill: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 10.304 25.756 C 14.577 31.756 20.529 31.756 25.304 25.756 M 25.304 25.756 L 21.102 25.756 M 25.304 25.756 L 25.304 30.068",
    stroke: "currentColor",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgNavIconReferrals;